import type { NumberSpeller } from './types'

// Odia 0–99 as spoken.
const ONES = [
  'ଶୂନ', 'ଏକ', 'ଦୁଇ', 'ତିନି', 'ଚାରି', 'ପାଞ୍ଚ', 'ଛଅ', 'ସାତ', 'ଆଠ', 'ନଅ',
  'ଦଶ', 'ଏଗାର', 'ବାର', 'ତେର', 'ଚଉଦ', 'ପନ୍ଦର', 'ଷୋହଳ', 'ସତର', 'ଅଠର', 'ଊଣେଇଶି',
  'କୋଡ଼ିଏ', 'ଏକୋଇଶି', 'ବାଇଶି', 'ତେଇଶି', 'ଚବିଶି', 'ପଚିଶି', 'ଛବିଶି', 'ସତାଇଶି', 'ଅଠାଇଶି', 'ଅଣତିରିଶି',
  'ତିରିଶି', 'ଏକତିରିଶି', 'ବତିଶି', 'ତେତିଶି', 'ଚଉତିରିଶି', 'ପଇଁତିରିଶି', 'ଛତିଶି', 'ସଇଁତିରିଶି', 'ଅଠତିରିଶି', 'ଅଣଚାଳିଶି',
  'ଚାଳିଶି', 'ଏକଚାଳିଶି', 'ବୟାଳିଶି', 'ତେୟାଳିଶି', 'ଚଉରାଳିଶି', 'ପଞ୍ଚଚାଳିଶି', 'ଛୟାଳିଶି', 'ସତଚାଳିଶି', 'ଅଠଚାଳିଶି', 'ଅଣଚାଶ',
  'ପଚାଶ', 'ଏକାବନ', 'ବାଉନ', 'ତେପନ', 'ଚଉବନ', 'ପଞ୍ଚାବନ', 'ଛପନ', 'ସତାବନ', 'ଅଠାବନ', 'ଅଣଷଠି',
  'ଷାଠିଏ', 'ଏକଷଠି', 'ବାଷଠି', 'ତେଷଠି', 'ଚଉଷଠି', 'ପଞ୍ଚଷଠି', 'ଛଅଷଠି', 'ସତଷଠି', 'ଅଠଷଠି', 'ଅଣସ୍ତରୀ',
  'ସତୁରୀ', 'ଏକସ୍ତରୀ', 'ବାସ୍ତରୀ', 'ତେସ୍ତରୀ', 'ଚଉସ୍ତରୀ', 'ପଞ୍ଚସ୍ତରୀ', 'ଛଅସ୍ତରୀ', 'ସତସ୍ତରୀ', 'ଅଠସ୍ତରୀ', 'ଅଣାଅଶୀ',
  'ଅଶୀ', 'ଏକାଅଶୀ', 'ବୟାଅଶୀ', 'ତେୟାଅଶୀ', 'ଚଉରାଅଶୀ', 'ପଞ୍ଚାଅଶୀ', 'ଛୟାଅଶୀ', 'ସତାଅଶୀ', 'ଅଠାଅଶୀ', 'ଅଣାନବେ',
  'ନବେ', 'ଏକାନବେ', 'ବୟାନବେ', 'ତେୟାନବେ', 'ଚଉରାନବେ', 'ପଞ୍ଚାନବେ', 'ଛୟାନବେ', 'ସତାନବେ', 'ଅଠାନବେ', 'ଅନେଶତ'
]

// A lone hundred is "ଶହେ"; otherwise "<n> ଶହ" ("ଦୁଇ ଶହ", "ଊଣେଇଶି ଶହ").
function hundreds(h: number): string {
  return h === 1 ? 'ଶହେ' : `${ONES[h]} ଶହ`
}

function withHundreds(h: number, r: number): string {
  return [h ? hundreds(h) : '', r ? ONES[r] : ''].filter(Boolean).join(' ')
}

function spell(n: number): string {
  if (n === 0) return ONES[0]
  const parts: string[] = []
  const units: Array<[number, string]> = [[10_000_000, 'କୋଟି'], [100_000, 'ଲକ୍ଷ'], [1000, 'ହଜାର']]
  let rest = n
  for (const [size, word] of units) {
    const q = Math.floor(rest / size)
    if (q) parts.push(`${spell(q)} ${word}`)
    rest %= size
  }
  if (rest) parts.push(withHundreds(Math.floor(rest / 100), rest % 100))
  return parts.join(' ')
}

export const or: NumberSpeller = {
  spell,
  // 2000–2099: "ଦୁଇ ହଜାର ଛବିଶି"; 1100–1999: "ଊଣେଇଶି ଶହ ପଚାଅଶୀ".
  year: (n) => (n >= 1100 && n < 2000 ? withHundreds(Math.floor(n / 100), n % 100) : spell(n)),
  rupees: 'ଟଙ୍କା'
}
